/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */
document.addEventListener("DOMContentLoaded", function () {
	// Initialize Splide slider if present
	const slides = document.getElementsByClassName("sp-main-splide");
	if (slides.length > 0) {
		const slidesArr = Array.from(slides);
		//console.log("slides:", slidesArr);
		slidesArr.forEach((e) => {
			var splide = new Splide(e, {
				type: "fade",
				perPage: 1,
				pagination: true,
				arrows: false,
				//direction: 'ttb',
				//height   : '22rem',
				breakpoints: {
					1024: {
						perPage: 1,
					},
				},
				autoplay: true,
				rewind: true,
				//interval: 500,
				speed: 1000,
				pauseOnHover: false
			});
			splide.mount();
		});
	}

	// Handle video loading
	const videos = document.querySelectorAll('.sp-main-video');
	videos.forEach((video) => {
		const overlay = video.parentElement.querySelector('.sp-video-loading-overlay');
		
		if (overlay) {
			// Hide overlay when video can play through
			const hideOverlay = () => {
				overlay.style.opacity = '0';
				setTimeout(() => {
					overlay.style.display = 'none';
				}, 500); // Match transition duration
			};

			// Check if video is already loaded
			if (video.readyState >= 3) {
				hideOverlay();
			} else {
				// Listen for video ready event
				video.addEventListener('canplaythrough', hideOverlay, { once: true });
				
				// Fallback: hide after 3 seconds even if not fully loaded
				setTimeout(hideOverlay, 3000);
			}

			// Handle video load error
			video.addEventListener('error', () => {
				console.error('Video failed to load');
				overlay.querySelector('.sp-loading-logo-container').innerHTML = 
					'<p class="text-white text-sm">Video unavailable</p>';
				setTimeout(hideOverlay, 2000);
			});
		}
	});
})
